'use strict';

var d3 = require('d3');
var Axes = function Axes(d3Helper, $filter) {
  return function (params) {
    var xAxisLabelText = 'Seats';
    var yAxisLabelText = 'Bid Price';
    var scales, axes;
    var xAxisLabel, yAxisLabel;
    var yAxisContainer;
    var updateXLabel, updateYLabel;
    var createXAxes, createYAxis;
    var rmNumberFormat = $filter('rmNumberFormat');
    var chartModel;
    createYAxis = function createYAxis(container) {
      var yAxis = d3.svg.axis().scale(scales.axisYScale).orient('left').ticks(params.yAxisTicks).tickFormat(function (d) {
        return rmNumberFormat(d, 'NUMBER_SHORT');
      });
      var containerWidth = container.node().getBoundingClientRect().width;
      var vector = [containerWidth - params.yAxisOffset, 0];
      var labelOffset = containerWidth - params.yAxisLabelOffset;
      var yAxisGroup = d3Helper.createGroupElement(container, 'y-axis').call(yAxis).attr('transform', 'translate(' + vector + ')');
      yAxisLabel = yAxisGroup.selectAll('.axes-label').data([null]);
      yAxisLabel.enter().append('text').attr({
        x: -params.height / 2,
        y: -labelOffset,
        "class": 'axes-label',
        transform: 'rotate(-90)'
      });
      updateYLabel();
    };
    updateYLabel = function updateYLabel(newLabel) {
      yAxisLabelText = newLabel || yAxisLabelText;
      if (yAxisLabel) {
        yAxisLabel.text(yAxisLabelText);
      }
    };
    createXAxes = function createXAxes(container) {
      var xAxis = d3.svg.axis().scale(scales.xScale).orient('bottom');
      var vector = [scales.xScale.range()[0], scales.yScale.range()[0]];
      var xAxisGroup = d3Helper.createGroupElement(container, 'x-axis').call(xAxis).attr('transform', 'translate(' + vector + ')');
      xAxisLabel = xAxisGroup.selectAll('.axes-label').data([null]);
      xAxisLabel.enter().append('text').attr({
        x: params.width / 2 - params.xAxisLabelOffset,
        y: 33,
        "class": 'axes-label'
      });
      updateXLabel();
    };
    updateXLabel = function updateXLabel(newLabel) {
      xAxisLabelText = newLabel || xAxisLabelText;
      if (xAxisLabel) {
        xAxisLabel.text(xAxisLabelText);
      }
    };
    axes = function axes(container) {
      container.call(createXAxes);
      if (yAxisContainer) {
        createYAxis(yAxisContainer);
      }
    };
    axes.scales = function (value) {
      if (!arguments.length) {
        return scales;
      }
      scales = value;
      return axes;
    };
    axes.yAxisContainer = function (container) {
      if (!arguments.length) {
        return yAxisContainer;
      }
      yAxisContainer = container;
      return axes;
    };
    axes.chartModel = function (value) {
      if (!arguments.length) {
        return chartModel;
      }
      chartModel = value;
      return axes;
    };
    return axes;
  };
};
Axes.$inject = ['d3Helper', '$filter'];
module.exports = Axes;